import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';
import log from '../../lib/log';
import { getSession, setSessionDeletionTimestamp } from '../../lib/sessions';
import { serviceState } from '../../lib/state';

// this is the handler that is triggered when user hangs up the call
async function handleSessionDeleted(event: Telecom.SessionDeletedEvent) {
  log('rtcs:session:deleted', event);

  appManager.events.emit<ServiceSessionEvent>(ServiceSessionEventType.DELETED, {
    sessionId: event.conversationId,
    sessionSid: event.conversationSid,
  });

  const session = getSession(event.conversationId);
  if (!session) {
    console.warn('session not found', event.conversationId);
    return;
  }

  // clear session
  delete serviceState.sessions[event.conversationId];
  // record deletion timestamp to avoid out-of-order offered event recreating deleted session
  setSessionDeletionTimestamp(event.conversationSid, event.timestamp);
}

export default handleSessionDeleted;
